import React, { Component } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { connect } from 'react-redux';
import { compose } from 'redux';

import logo from '../images/logo.svg';

class Footer extends Component {

	componentDidMount() {
		this.props.setRecaptcha(this.recaptcha);
		this.disableBadgeTabStop();
	}

	componentWillUnmount() {
		if (this.observer) {
			this.observer.disconnect();
		}
	}

	// Badge reCAPTCHY je z většinou mimo obrazovku, tabem na něj skákat nechceme
	disableBadgeTabStop = () => {
		const setTabIndex = () => {
			const iframe = this.footer && this.footer.querySelector('.grecaptcha-badge iframe');
			if (!iframe) {
				return false;
			}

			iframe.setAttribute('tabindex', '-1');
			return true;
		};

		if (setTabIndex()) {
			return;
		}

		this.observer = new MutationObserver(() => {
			if (setTabIndex()) {
				this.observer.disconnect();
			}
		});
		this.observer.observe(this.footer, { childList: true, subtree: true });
	};

	render() {
		return (
            <footer className="footer" ref={(el) => this.footer = el}>
				<a href="https://plazaro.com" target="_blank" rel="noopener noreferrer">
					<img src={logo} alt="Plazaro" className="footer__logo" />
				</a>

				<br />

				<ReCAPTCHA
					ref={(el) => this.recaptcha = el }
					size="invisible"
					sitekey={this.props.recaptchaSiteKey}
					onChange={this.props.recaptchaDidResolve}
				/>
            </footer>
		);
	}
}

export default compose(
	connect((state) => ({
		recaptchaSiteKey: state.app.recaptcha
	}))
)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.jsx